import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { McpHealthPanel } from '@/features/admin/McpHealthPanel';
import { CorpusHealthSection } from '@/features/admin/CorpusHealthSection';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin MCP Health route — platform operator's view of fleet-wide agent runs,
 * concurrency vs live caps, and tool health from the run database.
 * Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/mcp-health')({
  component: AdminMcpHealthPage,
});

function AdminMcpHealthPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="MCP Health"
        subtitle="Fleet-wide agent runs, concurrency vs live caps, and tool health from the run database. Egress, rate-limiter, and cache telemetry stay in the observe_mcp script for now."
      />
      <McpHealthPanel />
      <CorpusHealthSection />
    </AdminShell>
  );
}
